<app-reactive-dialog-content [data]="dialogInputData">
  <form [formGroup]="vollmachtForm">
    <label>
      <input type="radio" formControlName="vollmachtOption" [value]="VollmachtOption.LIEGT_AUF">
      Vollmacht liegt in der NV auf
    </label>
    <label>
      <input type="radio" formControlName="vollmachtOption" [value]="VollmachtOption.LIEGT_NICHT_AUF">
      Vollmacht liegt nicht in der NV auf
    </label>
    <label>
      <input type="radio" formControlName="vollmachtOption" [value]="VollmachtOption.ERZEUGEN_HOCHLADEN">
      Antragsdokument erzeugen/hochladen
    </label>
  </form>

  <div class="output-section">
    @if (vollmachtForm.value.vollmachtOption === VollmachtOption.ERZEUGEN_HOCHLADEN) {
      <p class="anweisung">
        Laden Sie zunächst das Antragsdokument herunter und
        anschließend das unterschriebene Exemplar wieder hoch.
      </p>
      <app-basic-icon-button icon="arrow_downward" (clickEvent)="createDocument()">
        Antrag erzeugen
      </app-basic-icon-button>
    }

    @if (vollmachtForm.value.vollmachtOption === VollmachtOption.LIEGT_NICHT_AUF) {
      <p class="anweisung">Bitte laden Sie hier die Vollmacht des Kunden hoch: </p>
    }

    @if (vollmachtForm.value.vollmachtOption === VollmachtOption.LIEGT_NICHT_AUF ||
    vollmachtForm.value.vollmachtOption === VollmachtOption.ERZEUGEN_HOCHLADEN) {

      <app-upload-file [currentDocuments]="currentDocuments" [uploadFileCallback]="uploadFileCallback"
                       [maxFilesAdded]="1" fabText="Dokument hochladen">
      </app-upload-file>

    }
  </div>

</app-reactive-dialog-content>

<mat-dialog-actions align="end">

  <app-basic-icon-button icon="add" (clickEvent)="submit()"
                         [disabled]="!isSaveEnabled">
    OK
  </app-basic-icon-button>

  <app-basic-icon-button icon="close" (clickEvent)="dialogRef.close()">
    Abbrechen
  </app-basic-icon-button>

</mat-dialog-actions>

